import React from 'react';
import { Banner } from './components/Banner';
import { AdvertorialPage } from './components/AdvertorialPage';
export function App() {
  return <div className="w-full min-h-full bg-white" data-id="element-0">
      <Banner data-id="element-1" />
      <AdvertorialPage data-id="element-2" />
    </div>;
}